module.exports = __webpack_public_path__ + "assets/img/warrior-name-c45ea6ca.png";